async function r() {
  if (typeof navigator.clipboard.write != "function" || typeof ClipboardItem != "function")
    return !1;
  try {
    const t = await navigator.permissions.query({
      name: "clipboard-write"
    });
    return t.state === "granted" || t.state === "prompt";
  } catch {
    return !0;
  }
}
export {
  r as canWriteToClipboard
};
